import {LOGIN_FAILURE, LOGIN_REQUEST, LOGIN_SUCCESS} from "./user/actions";
import userReducer, * as FromUser from "./user/reducer";


const initialState = {
    loading: {
        loading: {
            isLoadingUser: false,
        },
        user: null,
    }
};

const loadingReducer = (state, action) => {

    switch (action.type) {

        case LOGIN_REQUEST:

            return {
                ...state,
                isLoadingUser: true,
            };

        case LOGIN_SUCCESS:

            return {
                ...state,
                isLoadingUser: false,
            };

        case LOGIN_FAILURE:

            return {
                ...state,
                isLoadingUser: false,
            };

        default:

            return state;

    }

};

// -----------------------------------------------------------------------------
// REDUCER

export const reducer = (state = initialState, action) => {

    switch (action.type) {

        default:

            return {

                ...state,

                loading: loadingReducer(state.loading, action),

                user: userReducer(state.user, action),

            };

    }

};

// -----------------------------------------------------------------------------
// PRIVATE SELECTORS
// Loading
export function isLoadingUser(store) {
    return store.loading.isLoadingUser;
}

export function isLoadingClock(store) {
    return store.loading.isLoadingClock;
}

// User
export function isLoggedIn(store) {
    return FromUser.isLoggedIn(store.user);
}

export function hasPermission(store, permission) {
    return FromUser.hasPermission(store.user, permission);
}

export function isAdmin(store) {
    return FromUser.isAdmin(store.user);
}

export function getUserToken(store) {
    return FromUser.getToken(store.user);
}

export function getUser(store) {
    return FromUser.getUser(store.user);
}



// WEBPACK FOOTER //
// ./src/data/reducer.js